export default {
    methods: {
        getAppName (appId) {
            var appName = ''
            this.mchAppList.map(item => {
                if (item.appId === appId) {
                    appName = item.appName
                }
            })
            return appName || ''
        }
    }
}